export const formatDates = (dates) => {
    const [startDate, endDate] = dates;
    
    if (!startDate && endDate) {
    return [`تا ${endDate}`];
    } else if (startDate && !endDate) {
    return [`از ${startDate}`];
    } else if (startDate && endDate) {
    return [`از ${startDate} تا ${endDate}`];
    } else {
    return [];
    }
    };